export const DATA_KEY = 'heading-section';

export const SectionAttr = {
    DataId: 'data-diplodoc-id',
    DataKey: 'data-diplodoc-key',
} as const;

export const SectionCN = {
    Section: 'heading-section',
    Content: 'heading-section-content',
};
